import { render, staticRenderFns } from "./EmailProperties.vue?vue&type=template&id=04f5cc1e&"
import script from "./EmailProperties.vue?vue&type=script&lang=js&"
export * from "./EmailProperties.vue?vue&type=script&lang=js&"
import style0 from "./EmailProperties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports